'use strict';

module.exports = {
  appVersion: '7.2.0',

  jumpToScheme: function(opt) {
    var url = opt.url;
    var extra = opt.extra;
    if (extra) {
      url += '?' + this._convertUrlParams(extra);
      delete opt.extra;
      opt.url = url;
    }
    opt.toHome = !!opt.toHome ? 1 : 0;
    this._send('jumpToScheme', opt);
  },
  publish: function(opt) {
    var bizname = this._getBizName(opt);
    var CONSTS = ['phoneChanged', 'AccountBindChange'];
    if (bizname) {
      if (CONSTS.indexOf(opt.action) == -1) {
        opt.action = bizname + ':' + opt.action;
      }
      this._send('publish', opt);
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@dp/dpapp/lib/patch/patch-7.2.0.js
// module id = aZj3
// module chunks = 0